var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiplePractitioners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C4.78906 0.5 3 2.28906 3 4.5C3 6.71094 4.78906 8.5 7 8.5C9.21094 8.5 11 6.71094 11 4.5C11 2.28906 9.21094 0.5 7 0.5ZM7 2.5C8.10547 2.5 9 3.39453 9 4.5C9 5.60547 8.10547 6.5 7 6.5C5.89453 6.5 5 5.60547 5 4.5C5 3.39453 5.89453 2.5 7 2.5ZM14.5 2.5C13.1211 2.5 12 3.62109 12 5C12 6.37891 13.1211 7.5 14.5 7.5C15.8789 7.5 17 6.37891 17 5C17 3.62109 15.8789 2.5 14.5 2.5ZM15 8.5C13.5039 8.5 12.4023 9.02735 11.625 9.65625C13.9687 10.9805 14.8828 13 14.9375 13.125L15 13.3125V13.5H20V11.8438C20 11.8438 18.7969 8.5 15 8.5ZM7 9.5C1.68359 9.5 0 13.5 0 13.5V15.5H14V13.5C14 13.5 12.3164 9.5 7 9.5ZM7 11.5C10.4336 11.5 11.5312 13.5 11.5312 13.5H2.46875C2.46875 13.5 3.60937 11.5 7 11.5Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplePractitioners);
export default __webpack_public_path__ + "static/media/multiple-practitioners.f3708d4e98bfcd08dfe8bfc62497b898.svg";
export { ForwardRef as ReactComponent };